import React from 'react'

import EditBlockButton from './Controls/EditBlockButton'
import TriviaQuizModal from './Modals/TriviaQuizModal/TriviaQuizModal'

class TriviaQuiz extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
        }
    }

    openModal = evt => {
        evt.preventDefault()
        this.setState({
            showModal: true,
        })
    }
    closeModal = () => {
        this.setState({
            showModal: false,
        })
    }

    render() {
        const {
            blockData: { struct, colorTheme, id, t },
            onUpdate,
            methods,
        } = this.props
        const { showModal } = this.state
        return (
            <div className={`block __${t}`}>
                <EditBlockButton onClick={this.openModal} />

                {Object.keys(struct).length && struct._settings.showCover ? (
                    <div className="approx-preview">
                        {struct.cover.image ? (
                            <div className="image" style={{ backgroundImage: `url(${struct.cover.image})` }} />
                        ) : null}
                        <div className={`box${!struct.cover.image ? ' no-image' : ''}`}>
                            <div className="head">{struct.cover.header}</div>
                            {struct.cover.description.length ? (
                                <div className="description">{struct.cover.description}</div>
                            ) : null}
                            <div className="btn-wrap">
                                <div className="btn" style={{ backgroundColor: colorTheme }}>
                                    {struct.cover.buttonText}
                                </div>
                            </div>
                            {struct.cover.imageDisclaimer.length ? (
                                <div className="image-disclaimer">{struct.cover.imageDisclaimer}</div>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <div className="no-cover">
                        <div className="icon" />
                        <div className="text">
                            У этого теста нет обложки. Посмотреть и протестировать проект можно во вкладке
                            «Предпросмотр».
                        </div>
                    </div>
                )}

                {/* Modal */}
                {showModal ? (
                    <TriviaQuizModal
                        data={{
                            structure: struct,
                            colorTheme: colorTheme,
                            id,
                        }}
                        settings={{ max_width: 960, overlayClose: false }}
                        methods={{
                            openAssetManager: methods.openAssetManager,
                            closeModal: this.closeModal,
                            save: onUpdate,
                        }}
                    />
                ) : null}
            </div>
        )
    }
}

export default TriviaQuiz
